
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24.19 24.19"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Layer 1"}},[_c('path',{attrs:{"d":"M15.32 24.19l-3.23-3.07-3.23 3.06-1.29-4.27-4.33 1 1-4.33L0 15.32l3.07-3.23L0 8.86l4.27-1.29-1-4.33 4.33 1L8.86 0l3.23 3.07L15.32 0l1.29 4.27 4.33-1-1 4.33 4.27 1.28-3.07 3.23 3.06 3.23-4.27 1.29 1 4.33-4.33-1zm-3.23-4.45l2.74 2.6 1.09-3.61 3.67.86-.87-3.67 3.62-1.09-2.6-2.74 2.6-2.74-3.61-1.09.86-3.67-3.67.87-1.09-3.62-2.74 2.61-2.74-2.61-1.09 3.62-3.67-.87.87 3.67-3.62 1.09 2.61 2.74-2.61 2.74 3.62 1.09-.87 3.67 3.67-.87 1.09 3.62z"}}),_c('path',{staticStyle:{"isolation":"isolate"},attrs:{"d":"M10.73 16.1a.84.84 0 01.07-.35.85.85 0 01.19-.3 1 1 0 01.3-.2 1 1 0 01.72 0 1 1 0 01.29.2.88.88 0 01.2.3.85.85 0 01.08.35 1 1 0 01-.08.37.84.84 0 01-.2.29 1 1 0 01-.3.24.94.94 0 01-1-.2.81.81 0 01-.19-.29.94.94 0 01-.08-.41zm1.59-9.23v5.23l-.06.62c0 .22-.05.44-.08.68h-.92c0-.24-.05-.46-.08-.68l-.06-.62V6.87z"}})])])])
          )
        }
      }
    